// extracted by mini-css-extract-plugin
export default {"control":"BpsSegmentedControl_control__Uf-94","segment":"BpsSegmentedControl_segment__RkEbM","active":"BpsSegmentedControl_active__cys2s"};